export default __webpack_public_path__ + "static/media/img53.c08ed404.png";